import {
  LOGIN_FETCHING,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT,
  USER_BUDGET_PERMISSION_FETCHING,
  USER_BUDGET_PERMISSION_SUCCESS,
  USER_BUDGET_PERMISSION_FAIL,
  USER_PR_PERMISSION_SUCCESS,
  MENU_SYSTEM_FETCHING,
  MENU_SYSTEM_SUCCESS,
  MENU_SYSTEM_FAIL,
  USER_PR_PERMISSION_FETCHING,
  USER_PR_PERMISSION_FAIL,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";
import jwtDecode from "jwt-decode";

export const setStateToFetching = () => ({
  type: LOGIN_FETCHING,
});

export const setStateToSuccess = (payload) => ({
  type: LOGIN_SUCCESS,
  payload,
});

export const setStateToFailed = (payload) => ({
  type: LOGIN_FAILED,
  payload,
});

export const setStateToLogout = () => ({
  type: LOGOUT,
});

export const getMenu = () => {
  return (dispatch) => {
    dispatch({ type: MENU_SYSTEM_FETCHING });

    return httpClient
      .get(`/authen/menus`)
      .then((result) => {
        dispatch({ type: MENU_SYSTEM_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: MENU_SYSTEM_FAIL });
      });
  };
};

export const getPermission = () => {
  return (dispatch) => {
    dispatch({ type: USER_BUDGET_PERMISSION_FETCHING });

    const token = localStorage.getItem("token");

    if (token) {
      const dcode = jwtDecode(token);
      const { secureid } = dcode.sub;

      return httpClient
        .get(`/authen/permissions/${secureid}`)
        .then((result) => {
          dispatch({
            type: USER_BUDGET_PERMISSION_SUCCESS,
            payload: result.data,
          });
        })
        .catch((err) => {
          dispatch({ type: USER_BUDGET_PERMISSION_FAIL });
        });
    }
  };
};

export const login = (
  username,
  password,
  countryid,
  companyid,
  currency_code,
  currency_name,
  company,
  company_code,
  country,
  country_code,
  country_img,
  currency_id,
  history
) => {
  return async (dispatch) => {
    try {
      dispatch(setStateToFetching());
      const result = await httpClient.post(`/authen/signin`, {
        username,
        password,
        countryid,
        companyid,
        currency_code,
        currency_name,
        company,
        company_code,
        country,
        country_code,
        currency_id,
        country_img,
      });

      if (result) {
        const { message, icon, token, roles, rights, de_token } = result.data;

        if (message) {
          dispatch(setStateToFailed(message));
        } else {
          const dcode = jwtDecode(token);
          localStorage.setItem("token", token);
          localStorage.setItem("@de_token", de_token);
          // dispatch(getPermission());
          // dispatch(getMenu());

          // dispatch({
          //   type: USER_PR_PERMISSION_SUCCESS,
          //   payload: {
          //     roles,
          //     rights,
          //   },
          // });

          // setTimeout(() => {
          //   dispatch(setStateToSuccess(dcode.sub));
          //   history.replace("/dashboard");
          //   history.go();
          // }, 1000);

          dispatch(setStateToSuccess(dcode.sub));
          history.replace("/dashboard");
          history.go();
        }
      }
    } catch (error) {
      dispatch(setStateToFailed("Password invalid."));
    }
  };
};

export const getAuthorize = ({ perid }) => {
  return (dispatch) => {
    dispatch({
      type: USER_PR_PERMISSION_FETCHING,
    });

    httpClient
      .get(`/authen/authorize?perid=${perid}`)
      .then(({ data }) => {
        dispatch({
          type: USER_PR_PERMISSION_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => {
        dispatch({ type: USER_PR_PERMISSION_FAIL });
      });
  };
};

export const getDelegateRole = (perid, prhidx) => {
  return (dispatch) => {
    dispatch({
      type: "USER_DELEGATE_ROLE_FETCH",
    });

    httpClient
      .get(`/authen/delegate-role?userid=${perid}&prhidx=${prhidx}`)
      .then(({ data }) => {
        dispatch({
          type: "USER_DELEGATE_ROLE_SUCCESS",
          payload: data,
        });
      })
      .catch((err) => {
        dispatch({ type: "USER_DELEGATE_ROLE_REJECTED" });
      });
  };
};

export const isLoggedIn = () => {
  const loginStatus = localStorage.getItem("token");
  if (loginStatus) {
    return true;
  } else {
    return false;
  }
};

export const logout = ({ history }) => {
  return (dispatch) => {
    localStorage.removeItem("token");
    localStorage.removeItem("@de_token");
    dispatch(setStateToLogout());
    history.replace("/dashboard");
  };
};

export const setSuccess = (payload) => {
  return (dispatch) => {
    dispatch(setStateToSuccess(payload));
  };
};

export const hasError = (payload) => {
  return (dispatch) => {
    dispatch(setStateToFailed(payload));
  };
};
